import type { AppRouter } from "@app/lib/platform";

export const setQueryParam = (
  router: AppRouter,
  key: string,
  value: string
) => {
  const q = router.query;
  q[key] = value;

  // Preserve the hash when updating query params
  const hash = window.location.hash;

  void router
    .push(
      {
        pathname: router.pathname,
        query: q,
      },
      undefined,
      { shallow: true }
    )
    .then(() => {
      // Restore hash after router.push (Next.js doesn't preserve it)
      if (hash && window.location.hash !== hash) {
        window.history.replaceState(
          null,
          "",
          `${window.location.pathname}${window.location.search}${hash}`
        );
      }
    });
};

export const parseQueryString = (url: string) => {
  // Remove everything before the query string
  const queryString = url.split("?")[1] || "";
  const searchParams = new URLSearchParams(queryString);

  // Convert to plain object
  const params: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
};

export const getAgentBuilderRoute = (
  workspaceId: string,
  route: string,
  queryParams?: string
): string => {
  const basePath = "agents";
  const fullPath = `/w/${workspaceId}/builder/${basePath}${route === "manage" ? "" : `/${route}`}`;
  return queryParams ? `${fullPath}?${queryParams}` : fullPath;
};

export const getSkillBuilderRoute = (
  workspaceId: string,
  route: string,
  queryParams?: string
): string => {
  const basePath = "skills";
  const fullPath = `/w/${workspaceId}/builder/${basePath}${route === "manage" ? "" : `/${route}`}`;
  return queryParams ? `${fullPath}?${queryParams}` : fullPath;
};

export const getManageSkillsRoute = (workspaceId: string, skillId?: string) => {
  return (
    `/w/${workspaceId}/builder/skills` + (skillId ? `#?skillId=${skillId}` : "")
  );
};

export const getConversationRoute = (
  workspaceId: string,
  conversationIdOrNew: string | null = "new",
  queryParams?: string,
  baseUrl?: string
): string => {
  const conversationId = conversationIdOrNew ?? "new";
  const fullPath = `/w/${workspaceId}/conversation/${conversationId}`;
  const route = queryParams ? `${fullPath}?${queryParams}` : fullPath;
  return baseUrl ? `${baseUrl}${route}` : route;
};

export const getSpaceRoute = (workspaceId: string, spaceId: string) => {
  return `/w/${workspaceId}/spaces/${spaceId}`;
};

export const getPodRoute = (workspaceId: string, spaceId: string) => {
  return `/w/${workspaceId}/pods/${spaceId}`;
};
